/**
 * l2-cart-upsell — Carrusel crossfade del upsell del carrito.
 * - Todas las cards apiladas (grid, misma celda); solo `.is-on` visible. Sin scroll ni transform.
 * - Autoplay cada 4s (pausa al interactuar). Swipe táctil izquierda/derecha para cambiar.
 * - Añadir: POST /cart/add.js con la propiedad `_upsell-cart` para rastrear la línea en el pedido.
 * Todo delegado / global → sobrevive a los re-render (morph) del carrito.
 */

function l2cuShow(sl, idx) {
  const cards = sl.querySelectorAll('.l2cu-card');
  const n = cards.length;
  if (!n) return;
  idx = ((idx % n) + n) % n;
  sl.dataset.idx = String(idx);
  cards.forEach((c, i) => c.classList.toggle('is-on', i === idx));
  const wrap = sl.parentElement;
  const dots = wrap ? wrap.querySelectorAll('.l2cu-slider__dots span') : [];
  dots.forEach((d, i) => d.classList.toggle('is-on', i === idx));
}

// Autoplay 7s
setInterval(() => {
  document.querySelectorAll('.l2cu-slider').forEach((sl) => {
    if (sl.dataset.paused === '1') return;
    if (sl.querySelectorAll('.l2cu-card').length < 2) return;
    l2cuShow(sl, parseInt(sl.dataset.idx || '0', 10) + 1);
  });
}, 7000);

// Swipe táctil
let l2cuX = null;
document.addEventListener(
  'touchstart',
  (e) => {
    const sl = e.target.closest && e.target.closest('.l2cu-slider');
    if (sl) {
      l2cuX = e.touches[0].clientX;
      sl.dataset.paused = '1';
    }
  },
  { passive: true }
);
document.addEventListener(
  'touchend',
  (e) => {
    const sl = e.target.closest && e.target.closest('.l2cu-slider');
    if (sl && l2cuX != null) {
      const dx = e.changedTouches[0].clientX - l2cuX;
      if (Math.abs(dx) > 40) l2cuShow(sl, parseInt(sl.dataset.idx || '0', 10) + (dx < 0 ? 1 : -1));
      l2cuX = null;
      setTimeout(() => {
        sl.dataset.paused = '0';
      }, 4000);
    }
  },
  { passive: true }
);

// Pausa en hover (desktop)
document.addEventListener('mouseover', (e) => {
  const sl = e.target.closest && e.target.closest('.l2cu-slider');
  if (sl) sl.dataset.paused = '1';
});
document.addEventListener('mouseout', (e) => {
  const sl = e.target.closest && e.target.closest('.l2cu-slider');
  if (sl && !sl.contains(e.relatedTarget)) sl.dataset.paused = '0';
});

// Flechas prev/next
document.addEventListener('click', (e) => {
  const arr = e.target.closest('[data-l2cu-arrow]');
  if (!arr) return;
  const sl = arr.closest('.l2cu-slider');
  if (!sl) return;
  const dir = parseInt(arr.getAttribute('data-l2cu-arrow'), 10) || 1;
  l2cuShow(sl, parseInt(sl.dataset.idx || '0', 10) + dir);
  sl.dataset.paused = '1';
  setTimeout(() => {
    sl.dataset.paused = '0';
  }, 6000);
});

// Quick-add con propiedad _upsell-cart
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-l2cu-add]');
  if (!btn || btn.dataset.busy) return;
  const vid = btn.getAttribute('data-variant');
  if (!vid) return;

  btn.dataset.busy = '1';
  btn.classList.add('is-loading');
  const label = btn.innerHTML;
  // Spinner mientras se añade (se mantiene hasta que el re-render quita la card)
  btn.innerHTML = '<span class="l2cu-spin" role="status" aria-label="Añadiendo"></span>';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1, properties: { '_upsell-cart': 'sí' } }),
    });
  } catch (_) {
    btn.classList.remove('is-loading');
    delete btn.dataset.busy;
    btn.innerHTML = label;
  }
});
